import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '@/app/store/hooks';
import { fetchNotificationInbox } from '@/app/store/slices/notificationInboxSlice';
import { useNotificationConfig } from '@/hooks/useNotificationConfig';

/**
 * Keeps the authenticated user's notification inbox current independently of
 * the active page. The thunk's loading condition prevents overlapping pulls.
 */
export default function NotificationPollingBootstrap() {
    const dispatch = useAppDispatch();
    const isAuthenticated = useAppSelector((state) => state.authStore.isAuthenticated);
    const { pollIntervalMs } = useNotificationConfig();

    useEffect(() => {
        if (!isAuthenticated) return undefined;

        const refreshInbox = () => {
            dispatch(fetchNotificationInbox({ forceRefresh: true }));
        };

        // Pull immediately after authentication so users do not wait for the
        // first interval tick to see an alert created during their session.
        refreshInbox();
        const intervalId = setInterval(refreshInbox, pollIntervalMs);

        return () => clearInterval(intervalId);
    }, [dispatch, isAuthenticated, pollIntervalMs]);

    return null;
}
